import { Unit } from "types/landlord/address";
import { ListingSection } from "./ListingSection";
import { GeneralSection } from "./GeneralSection";
import { PlanSection } from "./PlanSection";
import { AmenitiesSection } from "./AmenitiesSection";
import { PhotosSection } from "./PhotosSection";
import { Show } from "shared/components";
import { RentalInfoSection } from "shared/app/RentalInfoSection";

interface UnitDetailsProps {
  unit?: Unit;
}

export const UnitDetails = ({ unit }: UnitDetailsProps) => {
  if (!unit) return null;

  return (
    <div>
      <div className="space-y-4 max-w-[822px] w-full">
        <ListingSection
          propertyKind={unit.property.kind}
          propertyId={unit.property.id}
          unit={unit}
        />
        <GeneralSection unit={unit} />
        <RentalInfoSection unit={unit} />
        <Show if={unit.property.kind}>
          <PlanSection unit={unit} />
          <AmenitiesSection unit={unit} />
          <PhotosSection unit={unit} />
        </Show>
      </div>
    </div>
  );
};
